import React, { useRef, useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';
import clsx from 'clsx';

import { useMediaQuery } from '@material-ui/core';
// import { useTheme } from '@material-ui/core/styles';
import { breakpoints } from '../../../../styles/themes/vad/constants';
import { COMPONENT_NAME, LOCATION, SOCIAL_ICONS } from './locators';

import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useTheme } from '@material-ui/core/styles';
import Grid from '../../../components/molecules/Grid';
import StickyBar from '../../../components/atoms/StickyBar';
import Box from '../../../components/molecules/Box';
import Link from '../../../components/atoms/Link';
import Button from '../../../components/atoms/Button';
import Typography from '../../../components/atoms/Typography';
import DctSvgIcon from '../../../components/atoms/Svg';
import Rating from '../../../components/atoms/Rating';
import Overlay from '../../../components/atoms/Overlay';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { analyticsData } from '../../../../../src/constants/Analytics/analytics-data';
import smoothScrollTo from '../../../utils/Polyfill/smoothScrollTo';
import { formatArabicLangMonth, getDateInFormat } from '../../../utils/dateTimeFunctions/dateTimeFunctions';

import useStyles from './style';
import {
  EVENT_LIST_TEMPLATE_NAME,
  ITINERARY_LIST_TEMPLATE_NAME,
} from './constants';
import {
  EVENTS_THEME_COLOR,
  LISTING_THEME_COLOR,
  EVENT_TYPE,
  TICKET_COMPONENT_ID,
  TICKETED_EVENT_TEXT,
  LOCALSTORAGE_PRICE_KEY,
} from '../../../../constants';
import {
  pushAnaylyticsData,
  createDynamicLabels,
} from '../../../../utils/analytics';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';
import { canUseDOM } from '../../../utils/canUseDOM';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { isItineraryExist, validateUrl } from '../../../../utils/utility';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { FAQ_TEMPLATE_ID, EVENT_DETAILS_TEMPLATE_ID, DETAILS_TEMPLATE_IDS_ARRAY } from '../../../../constants/index';
import Favorite from '../../../components/atoms/Favorite';
import ButtonMUI from '../../../components/atoms/Button';
import { getUTCDateInUAEFormat } from '../../../utils/dateTimeFunctions/dateTimeFunctions';
import { isItineraryModalOpen } from '../ItineraryBuilderMap/redux/actions';
import ItineraryBuilder from '../ItineraryBuilder';
import { useDispatch } from 'react-redux';
import { removeDashesFromString } from '../../../utils/string-utils';

// #TODO: Needs to check export.
export const StickyStripBanner = props => {
  const { sitecoreContext, t: dictionary } = props;
  let {
    name,
    email,
    rating,
    instagramUrl,
    facebookUrl,
    twitterUrl,
    websiteUrl,
    youtubeUrl,
    phoneNumber,
    primaryCTAs: primaryCTA,
    location,
    isPaid,
    onlineBookingLink,
    eventStartDateTime,
    eventEndDateTime
  } = get(sitecoreContext, 'route.fields', '');
  let eventType = '';

  const dispatch = useDispatch();
  eventStartDateTime = { value: getDateInFormat(eventStartDateTime.value, "MM/DD/YYYY hh:mm:ss A") }
  eventEndDateTime = { value: getDateInFormat(eventEndDateTime.value, "MM/DD/YYYY hh:mm:ss A") }

  if (
    isPaid &&
    isPaid.value &&
    (isPaid.value === 'true' || isPaid.value === true)
  ) {
    eventType = TICKETED_EVENT_TEXT;
  }
  const contentType = get(
    sitecoreContext,
    'route.fields.contentType.fields.taxonomyKey.value',
    ''
  ).toLowerCase();
  const pageName = getPageName(props);
  const componentName = getComponentName(props);
  const siteCoreRoute = get(props, 'sitecoreContext.route', {});
  const templateId = get(siteCoreRoute, 'templateId', '');
  const itemUniqueKey = removeDashesFromString(get(siteCoreRoute, 'itemId', ''));
  const theme = useTheme();
  const isRTL = theme && theme.direction === 'rtl';
  const [hasFavouriteBasket, setHasFavouriteBasket] = useState(false);
  const vadHeader = get(
    props,
    'sitecoreContext.VADStaticRoute.sitecore.route.placeholders.vad-header',
    []
  );

  useEffect(() => {
    const favouriteBasket = vadHeader.find(
      item => item.componentName === 'FavoriteBasket'
    );
    const favIsActive = get(
      favouriteBasket,
      'fields["Is Active"].value',
      false
    );

    const isDetailsTemplateId = DETAILS_TEMPLATE_IDS_ARRAY.indexOf(templateId) > -1;
    setHasFavouriteBasket(Boolean(favouriteBasket) && favIsActive && isDetailsTemplateId);
  }, [vadHeader]);

  // const ratingOutOf = dictionary('outOf5');
  const stickyViewDetail = (dictionary && dictionary('stickyViewDetail')) || '';
  const primaryTextFromDictionary =
    (dictionary && dictionary('bookNowText')) || '';
  const secondaryCTA = {
    value: {
      text: stickyViewDetail,
    },
  };
  const emailValue =
    get(email, 'value.text', '') || getDictionaryText('emailCTA');
  const phoneNumValue = get(phoneNumber, 'value', '');
  const urlValue =
    get(websiteUrl, 'value.text', '') || getDictionaryText('websiteCTA');
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.md}px)`);
  const isMobileSM = useMediaQuery(`(max-width:${breakpoints.values.sm}px)`);
  // This comments for Event page
  const themeColor =
    contentType === EVENT_LIST_TEMPLATE_NAME
      ? EVENTS_THEME_COLOR
      : LISTING_THEME_COLOR;
  const isIternaryListingPage = contentType === ITINERARY_LIST_TEMPLATE_NAME;
  const classes = useStyles({ themeColor });

  const secTitleRef = useRef(null);
  const beforeStickyBarRef = useRef(null);
  const buyTicket = get(onlineBookingLink, 'value.href', '')
  const isExternal = get(onlineBookingLink, 'value.linktype', '')
  const isTargetBlank = isExternal == "external" ? '_blank' : ''

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    setTimeout(() => {
      if (!isMobile && secTitleRef && secTitleRef.current && beforeStickyBarRef && beforeStickyBarRef.current) {
        let haveAnimatedOnce = false;
        gsap.timeline({
          scrollTrigger: {
            trigger: beforeStickyBarRef.current,
            start: 'top bottom',
            end: `+=${window.innerHeight * 0.2}px bottom`,
            scrub: true,
            once: true,
            onUpdate: self => {
              if (self.progress > 0.5) {
                secTitleRef && secTitleRef.current.animPlay();
                haveAnimatedOnce = true;
              } else if (haveAnimatedOnce) {
                secTitleRef && secTitleRef.current.animReverse();
              }
            },
          },
        });
      }
    }, 100);

    // Adds 'ghostdiv-reached' class to the sticky bar when rendered 
    setTimeout(() => {
      if (canUseDOM) {
        const stickyBar = document.querySelector('#stickyBar')
        if (stickyBar) {
          stickyBar.classList.add('ghostdiv-reached')
        }
      }
    }, 100)
  }, []);

  const renderSocialMediaIcons = () => {
    // Making youtube's url as other social links.
    if (youtubeUrl && youtubeUrl.value && !youtubeUrl.value.href) {
      youtubeUrl.value = {
        href: youtubeUrl.value,
        linktype: 'external',
        target: '_blank',
      };
    }
    const arr = [
      { link: twitterUrl, iconName: 'TwitterIcon', iconText: 'Twitter' },
      { link: instagramUrl, iconName: 'InstagramIcon', iconText: 'Instagram' },
      { link: facebookUrl, iconName: 'FacebookIcon', iconText: 'Facebook' },
      { link: youtubeUrl, iconName: 'YouTubeIcon', iconText: 'YouTube' },
    ];
    return arr.map((icon, i) => {
      if (get(icon, 'link.value.href') && validateUrl(get(icon, 'link.value.href'))) {
        return (
          <Link
            field={icon.link}
            key={i}
            data-id={get(analyticsData, 'dataIds.pageBodyNavLinkClick')}
            title={icon.iconText}
            data-link={createDynamicLabels([
              pageName,
              componentName,
              `${get(analyticsData, 'dataLinksText.socialShare')}-${icon.iconName
              }`,
            ])}
          >
            <Button
              iconOnly={true}
              component="span"
              srText={icon.iconName}
              className={clsx({
                facebookIcon: icon.iconName === 'FacebookIcon',
              })}
              tabIndex="-1"
            >
              <DctSvgIcon name={icon.iconName} />
            </Button>
          </Link>
        );
      }
      return null;
    });
  };

  const nativeSmoothScrollTo = elem => {
    setTimeout(function () {
      window.scrollTo({
        top: elem.offsetTop - window.innerHeight / 2 + 200,
        left: 0,
        behavior: 'smooth',
      });
    }, 100);
  };

  const addStickyBtnAnalytics = ctaTextForAnalytics => {
    if (canUseDOM) {
      document.querySelector('.overlayCloseBtn') &&
        document.querySelector('.overlayCloseBtn').click();
      let ticketComponentDom = document.getElementById(TICKET_COMPONENT_ID);
      if (ticketComponentDom) {
        // detect support for the behavior property in ScrollOptions
        const supportsNativeSmoothScroll =
          'scrollBehavior' in document.documentElement.style;
        if (supportsNativeSmoothScroll) {
          nativeSmoothScrollTo(ticketComponentDom);
        } else {
          smoothScrollTo(
            ticketComponentDom.offsetTop - window.innerHeight / 2 + 200,
            700
          );
        }
      }
    }

    const obj = {
      ...get(analyticsData, 'pageBodyInteraction.primaryCTAClick'),
      ...{
        action: createDynamicLabels([
          pageName,
          componentName,
          ctaTextForAnalytics,
        ]),
      },
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          name && name.value,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };

  const renderPrimaryCTA = () => {
    let btnText = get(primaryCTA, 'value.text', '');
    let primaryCTAField = { ...primaryCTA };
    if (contentType === EVENT_TYPE) {
      btnText = primaryTextFromDictionary;
      primaryCTAField = { value: { text: btnText } };
    }
    return btnText && !!getfirstTicketValue ? (
      <div className={classes.dflex}>
        {isMobile && <div className={classes.vdiv}></div>}

        <Button
          field={primaryCTAField}
          type="button"
          buttonType="form"
          size="small"
          hasBorder={false}
          onClick={e => {
            if (contentType === EVENT_TYPE) {
              e.preventDefault();
            }
            addStickyBtnAnalytics(getDictionaryText('ADgetTicketsMobile'));
          }}
          // This comments for Event page
          themeColor={
            contentType === EVENT_LIST_TEMPLATE_NAME ? EVENTS_THEME_COLOR : ''
          }
        >
          <Typography
            variant="subtitle2"
            component="span"
            color="inherit"
            className="primaryCTA"
          >
            <Text field={{ value: getDictionaryText('ADgetTicketsMobile') }} />
          </Typography>
        </Button>
      </div>
    ) : null;
  };

  const renderFavoriteIconSection = (isDetailPresent) => {
    return (
      <>{hasFavouriteBasket &&
        <Favorite
          hideToast={true}
          ariaLabel={name.value}
          itemUniqueKey={itemUniqueKey}
          componentName={componentName}
          dictionary={dictionary}
          contentType={contentType}
          isDetailPresent={isDetailPresent}
        />
      }
      </>
    )
  }

  const renderCTASection = () => {
    return (
      <Box className={`cta-wrap ${classes.ctaWrapper}`}>
        <Box className='heartMobile'>
          {renderFavoriteIconSection()}
        </Box>
        {/* {stickyViewDetail && isDetailPresent && (
          <Overlay
            primaryCTA={secondaryCTA}
            buttonProps={{
              hasBorder: false,
              size: 'small',
              buttonType: 'secondary',
              className: 'secondaryCTA',
            }}
            className={classes.modalPopUp}
            from="StickyStripBanner"
            node={
              renderFavoriteIconSection()
            }
          >
            {renderCommonLayout()}
          </Overlay>
        )} */}
        {(contentType === EVENT_TYPE
          ? eventType === TICKETED_EVENT_TEXT
          : getPrimaryCTAValue()) && renderPrimaryCTA()}
      </Box>
    );
  };
  const addWebsiteClickAnaltics = () => {
    const obj = {
      ...get(analyticsData, 'pageBodyInteraction.visitWebsiteClick'),
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          name && name.value,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };
  const isDetailPresent = emailValue || phoneNumValue || urlValue;
  const hasDetails = email?.value?.href || phoneNumValue || websiteUrl?.value?.href;
  const socialIcons = renderSocialMediaIcons().filter(item => item !== null);
  const btnText = get(primaryCTA, 'value.text', '');

  /* Get sitecore context & extract ticketsDataLength */
  // from sitecoreContext.route.placeholders.vad-main array get object with componentName="tickets"
  const vadMain = get(
    sitecoreContext,
    'route.placeholders.vad-main',
    []
  );
  // get object with componentName="tickets" from ticketsData
  const ticketsData = get(
    vadMain,
    vadMain.findIndex(item => item.componentName === 'DetailSubLayout'),
    0
  );

  // Extracting the "Tickets" component data from placeholders
  const ticketsComponent = ticketsData.placeholders['vad-left-col'].find(item => item.componentName === 'Tickets');
  const getfirstTicketValue = get(ticketsComponent, 'fields.ticket[0].fields.ticketPrice.value', null)

  // Get ticketsData Length
  const ticketsWithUrls = ticketsData && ticketsData.fields &&
    ticketsData.fields.ticket && ticketsData.fields.ticket.filter(item => item?.fields?.ticketWebUrl?.value)
  const ticketsDataLength = ticketsWithUrls?.length

  const getPrimaryCTAValue = () => {
    const value = primaryCTA && primaryCTA.value;
    if (!value) {
      return false;
    }
    const { href, linktype } = value;
    return value && href && linktype !== 'mailto' ? href !== ('http://' || 'https://') : href
  }

  /**
   * Add To Iteranry Logic
   */
  const [modalPop, setModalPop] = useState(false);

  const onClickHandler = (e) => {
    e.preventDefault()
    dispatch(isItineraryModalOpen(true))
    setModalPop(true)
  }

  let itineraryList = isItineraryExist();

  const createSVG = (type = '', fill = '', customClass = '') => {
    switch (type) {
      case 'iteranaryIcon':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_2670_8281)">
              <path d="M13 12C13 12.5304 12.7893 13.0391 12.4142 13.4142C12.0391 13.7893 11.5304 14 11 14C10.4696 14 9.96086 13.7893 9.58579 13.4142C9.21071 13.0391 9 12.5304 9 12V4C9 2.93913 8.57857 1.92172 7.82843 1.17157C7.07828 0.421427 6.06087 0 5 0C3.93913 0 2.92172 0.421427 2.17157 1.17157C1.42143 1.92172 1 2.93913 1 4V10H3V4C3 3.46957 3.21071 2.96086 3.58579 2.58579C3.96086 2.21071 4.46957 2 5 2C5.53043 2 6.03914 2.21071 6.41421 2.58579C6.78929 2.96086 7 3.46957 7 4V12C7 13.0609 7.42143 14.0783 8.17157 14.8284C8.92172 15.5786 9.93913 16 11 16C12.0609 16 13.0783 15.5786 13.8284 14.8284C14.5786 14.0783 15 13.0609 15 12V6H13V12Z" fill={fill ? fill : `#444444`} />
              <path d="M4 12H0V16H4V12Z" fill={fill ? fill : `#444444`} />
              <path d="M16 0H12V4H16V0Z" fill={fill ? fill : `#444444`} />
            </g>
            <defs>
              <clipPath id="clip0_2670_8281">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        )
        break;
      default:
        return <></>
    }
  }

  function formatDateRange(startDate = '', endDate = '') {

    const startDateYear = startDate ? getUTCDateInUAEFormat(startDate, 'YYYY') : '';
    const startDateMonth = startDate ? getUTCDateInUAEFormat(startDate, 'MMM') : '';
    const startDateDay = startDate ? getUTCDateInUAEFormat(startDate, 'DD') : '';
    const endDateYear = endDate ? getUTCDateInUAEFormat(endDate, 'YYYY') : '';
    const endDateMonth = endDate ? getUTCDateInUAEFormat(endDate, 'MMM') : '';
    const endDateDay = endDate ? getUTCDateInUAEFormat(endDate, 'DD') : '';
    const endDateMonthTitle = isRTL ? formatArabicLangMonth(endDate) : endDateMonth
    const startDateMonthTitle = isRTL ? formatArabicLangMonth(startDate) : startDateMonth
    let formattedDateAndTime = `${startDateDay}`;
    if (startDateYear !== endDateYear) {
      formattedDateAndTime += ` ${startDateMonthTitle} ${startDateYear} - ${endDateDay} ${endDateMonthTitle} ${endDateYear}`
    } else if (startDateMonth !== endDateMonth) {
      formattedDateAndTime += ` ${startDateMonthTitle} - ${endDateDay} ${endDateMonthTitle} ${endDateYear}`
    } else if (startDateDay !== endDateDay) {
      formattedDateAndTime += ` - ${endDateDay} ${endDateMonthTitle} ${endDateYear}`
    } else {
      formattedDateAndTime += ` ${endDateMonthTitle} ${endDateYear}`
    }

    return formattedDateAndTime;
  }

  const renderCommonLayout = () => {
    return (
      <React.Fragment>
        {name && (
          <Typography
            variant="h5"
            component="p"
            className={`page-title ${isMobile && 'sticky-hidden'} ${classes.pageTitle
              }`}
            ref={secTitleRef}
            title={name.value}
            wordBreak
            animateSettings={{
              selfTriggerMobOnly: true,
              willAnimate: true,
            }}
          >
            <span>
              <Text field={name} />
            </span>
            {rating && <Rating rating={rating.value} className="rating" />}
          </Typography>
        )}
        {/* {location && !isIternaryListingPage && (
          <Typography
            variant="body2"
            component="p"
            className={`sticky-hidden ${classes.location}`}
            data-locator={LOCATION}
          >
            <Text field={location} />
          </Typography>
        )} */}
        {(isDetailPresent || socialIcons.length > 0 || btnText) && (
          <Grid
            container
            className={`detail-section ${classes.detailSection} ${btnText &&
              'btn-present'}`}
          >
            <Box className='desktopSectionWrap'>
              <Typography className={'date'} component={'p'} variant={'h5'}>
                {formatDateRange(eventStartDateTime.value, eventEndDateTime.value)}
              </Typography>
              <Box className='fav-icon-iteranary-container'>
                {renderFavoriteIconSection('contacts-section')}
                <ButtonMUI
                  type="button"
                  buttonType="form"
                  size="small"
                  tabIndex={0}
                  hasBorder={false}
                  className="sticky-iteranary-btn"
                  isStartIcon={false}
                  onClick={(e) => onClickHandler(e)}
                  endIconSvg={createSVG('iteranaryIcon')}
                >
                  {getDictionaryText(itineraryList ? 'AddToItinerary' : 'Create')}
                </ButtonMUI>
              </Box>
            </Box>
            {isDetailPresent && (
              <Box
                className={clsx('contacts-section', classes.contacts, {
                  'sticky-hidden': isMobile,
                  'hideFavText': hasDetails || socialIcons.length > 0 || btnText,
                })
                }
              >

                {renderFavoriteIconSection('contacts-section')}

                {/* {hasDetails && <div className={clsx(classes.verticalBar,
                  {
                    'ml4': hasDetails || socialIcons.length > 0 || btnText,
                  })}></div>}

                {emailValue && email?.value?.href && (
                  <Link
                    link={email}
                    className={classes.contactTxt}
                    data-id={get(
                      analyticsData,
                      'dataIds.pageBodyNavLinkClick',
                      ''
                    )}
                    data-link={createDynamicLabels([
                      pageName,
                      componentName,
                      get(analyticsData, 'dataLinksText.contactByEmail'),
                    ])}
                  >
                    <Typography
                      variant="body2"
                      component="span"
                      color="inherit"
                    >
                      <Text field={{ value: emailValue }} />
                    </Typography>
                  </Link>
                )}
                {phoneNumValue && (
                  <Link
                    link={{
                      value: {
                        href: `tel:${phoneNumValue}`,
                        text: phoneNumValue,
                      },
                    }}
                    data-id={get(analyticsData, 'dataIds.pageBodyNavLinkClick')}
                    data-link={createDynamicLabels([
                      pageName,
                      componentName,
                      get(analyticsData, 'dataLinksText.contactByPhone'),
                    ])}
                    className={`${classes.contactTxt} no-flip`}
                  >
                    <Typography
                      variant="body2"
                      component="span"
                      color="inherit"
                    >
                      <Text field={phoneNumber} />
                    </Typography>
                  </Link>
                )}
                {urlValue && websiteUrl?.value?.href && (
                  <Link
                    link={websiteUrl}
                    onClick={addWebsiteClickAnaltics}
                    className={classes.contactTxt}
                  >
                    <Typography
                      variant="body2"
                      component="span"
                      color="inherit"
                    >
                      <Text field={{ value: urlValue }} />
                    </Typography>
                  </Link>
                )} */}
                {!!getfirstTicketValue && < Typography className={'priceTag'} component={'p'} variant={'body2Light'}>{isMobileSM ? getDictionaryText('AdStartPriceMobile') : getDictionaryText('AdStartPriceDesktop')} <Typography component={'span'} className='price_tag_value' variant={'h5'}>{Math.floor(getfirstTicketValue)}</Typography></Typography>}
                {!!getfirstTicketValue && <ButtonMUI
                  className={'ticketCta'}
                  buttonType={'form'}
                  target={isTargetBlank}
                  onClick={e => {
                    if (contentType === EVENT_TYPE) {
                      e.preventDefault();
                    }
                    addStickyBtnAnalytics(getDictionaryText('ADgetTickets'));
                  }}
                  type={'submit'}
                  // href={buyTicket}
                  hasBorder={false}
                  size="small"
                // field={{ value: { text: fields.fieldLabel.value } }}
                // disabled={!isFormValid}
                >{getDictionaryText('ADgetTickets')}</ButtonMUI>}
              </Box>
            )}
            {/* {socialIcons.length > 0 && (
              <Box
                className={clsx('sticky-hidden', classes.socialIcons)}
                mb={{ xs: 3, lg: 0 }}
                data-locator={SOCIAL_ICONS}
              >
                <div className={`${classes.verticalBar} ${classes.ml30}`}></div>
                {socialIcons}
              </Box>
            )} */}
            {/* {(contentType === EVENT_TYPE && ticketsDataLength
              ? eventType === TICKETED_EVENT_TEXT
              : getPrimaryCTAValue()) && (
                <Box
                  className={clsx(
                    {
                      'mobile-cta-wrap': isMobile,
                    },
                    classes.ctaWrapper
                  )}
                >
                  <div className={`${classes.verticalBar} ${classes.ml30}`}></div>
                  {renderPrimaryCTA()}
                </Box>
              )} */}
          </Grid>
        )
        }
      </React.Fragment >
    );
  };

  return (
    <>
      <div ref={beforeStickyBarRef} />
      <StickyBar>
        <Box data-locator={COMPONENT_NAME}>
          <Grid container direction="column" className="section-container">
            {renderCommonLayout()}
            {isMobile &&
              templateId !== FAQ_TEMPLATE_ID &&
              (isDetailPresent || socialIcons.length > 0 || btnText) &&
              renderCTASection()}
          </Grid>
        </Box>
      </StickyBar>
      <div id="ghostDiv"></div>
      <ItineraryBuilder
        navigateOnSubmit={true}
        itemUniqueKey={itemUniqueKey}
        itineraryExist={itineraryList}
        customClass={itineraryList ? 'addItenary' : 'createItinerary'}
        open={modalPop}
        handleExit={() => {
          setModalPop(false);
        }}
        setIsOpen={e => {
          setModalPop(e);
        }}
      />
    </>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(StickyStripBanner))
);


